// extracted by mini-css-extract-plugin
export default {"MenuContainer":"HeaderMenu_MenuContainer__8DGzo"};